export default "__VITE_ASSET__0b4bee4e__"